import { useContext, useEffect, useState } from "react";
import { BreadTransaction, P } from "breadcommon";
import { RyeSearchBar } from "../rye/RyeSearchBar";
import { TransactionColumn } from "./TransactionColumn";
import { TransactionsNavContext } from "./TransactionsScreen";
import { TransactionColumnFilterProps } from "./DefaultTransactionColumnHeader";
import { buildClasses } from "../utils/buildClasses";

export function TransactionColumnFilterDescription({
  isOpen,
  onClose,
  hasActiveFilter,
}: TransactionColumnFilterProps): JSX.Element | null {
  const [transactionsNav, setTransactionsNav] = useContext(
    TransactionsNavContext,
  );
  const [filterText, setFilterText] = useState<string>("");
  const [shouldFocus, setShouldFocus] = useState<boolean>(true);

  useEffect(() => {
    if (!hasActiveFilter) {
      setFilterText("");
    }
  }, [hasActiveFilter]);

  useEffect(() => {
    if (isOpen) {
      setShouldFocus(true);
    }
  }, [isOpen]);

  function handleAckFocus() {
    setShouldFocus(false);
  }

  function createDescriptionPredicate(
    searchText: string,
    isExactMatch: boolean,
  ) {
    const field = P.Field<BreadTransaction, "description">("description");
    const literal = P.Literal(searchText);

    if (isExactMatch) {
      return P.EqualsCI(field, literal);
    } else {
      return P.SubstringCI(field, literal);
    }
  }

  function handleSearch(searchText: string, isExactMatch: boolean) {
    setFilterText(searchText);

    const currentSettings =
      transactionsNav.columnSettings[TransactionColumn.DESCRIPTION];
    setTransactionsNav((prevState) => ({
      ...prevState,
      columnSettings: {
        ...transactionsNav.columnSettings,
        [TransactionColumn.DESCRIPTION]: {
          ...currentSettings,
          predicate:
            searchText.trim() === ""
              ? null
              : createDescriptionPredicate(searchText.trim(), isExactMatch),
        },
      },
    }));
  }

  if (!isOpen) {
    return null;
  }

  return (
    <div className={buildClasses("shadow-md", "rounded-md", "bg-surface")}>
      <RyeSearchBar
        search={handleSearch}
        startingText={filterText}
        size="md"
        width="lg"
        focus={shouldFocus}
        ackFocus={handleAckFocus}
        showExactMatchButton={true}
        variant="outlined"
        shape="rounded-rect"
      />
    </div>
  );
}
